export default "__VITE_ASSET__bx94APIv__"